module.exports = __webpack_public_path__ + "img/paystack.3740f911.png";